import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createChallenge(_, challenge) {
    const response = await axios.post('/blade/challenges', challenge);
    return response.data.challenge;
  },
  async getChallenges() {
    const response = await axios.get('/blade/challenges');
    return response.data.challenges;
  },
  async getChallenge(_, { challengeId }) {
    const { data } = await axios.get(`/blade/challenges/${challengeId}`);
    return data;
  },
  async getChallengeTypes({ dispatch }) {
    return dispatch('getChallenge', { challengeId: 'types' });
  },
  async updateChallenge(_, challenge) {
    const response = await axios.patch(`/blade/challenges/${challenge._id}`, challenge);
    return response.data.challenge;
  },
  async deleteChallenge(_, { challengeId, _id }) {
    const did = challengeId || _id;
    const response = await axios.delete(`/blade/challenges/${did}`);
    return response.data.challenge;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/challenges.js